import React, {useState} from 'react';
import {Flex} from "antd";
import Forecasts from './forecasts/index';
import PeriodForm from './PeriodForm';
import { Engine } from '../../../api/types';

interface ReportProps {
  briefId: number,
  engine: Engine,
}

export default function Report({briefId, engine}: ReportProps) {
  return (
    <Flex className={'report__wrapper'} vertical gap={20}>
      <PeriodForm
        engine={engine}
      />

      <Forecasts
        engineId={engine.id}
        briefId={briefId}
      />
    </Flex>
  )
}
